import React from 'react';
import { IMPACT_STATS, PARTNERS } from '../data/mock';
import CountUp from './CountUp';

function parseStat(str) {
  const m = String(str).match(/^([\d,.]+)(.*)$/);
  if (!m) return { num: 0, suffix: str, decimals: 0 };
  const raw = m[1];
  const decimals = raw.includes('.') ? 1 : 0;
  return { num: parseFloat(raw.replace(/,/g, '')), suffix: m[2], decimals };
}

export default function Impact() {
  return (
    <section id="impact" className="relative py-24 lg:py-28 bg-[#FDF8F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-14">
          <div>
            <span className="text-[12.5px] uppercase tracking-[0.22em] font-semibold text-[#E85A18]">
              Clinical Impact
            </span>
            <h2
              className="mt-3 text-[36px] sm:text-[42px] lg:text-[50px] leading-[1.05] tracking-[-0.025em] text-[#0F1B2D] font-semibold"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Real numbers from India’s hospitals & homes.
            </h2>
          </div>
          <p className="text-[15.5px] text-slate-600 max-w-lg leading-relaxed">
            Every deployment is measured by the patients whose recovery accelerates and the clinicians whose workflows get faster.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {IMPACT_STATS.map((s, i) => {
            const { num, suffix, decimals } = parseStat(s.value);
            return (
            <div
              key={s.label}
              className="relative rounded-2xl bg-white border border-orange-100/80 p-7 overflow-hidden hover:shadow-[0_25px_60px_-30px_rgba(232,90,24,0.35)] hover:-translate-y-1 transition-all duration-500"
            >
              <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-[radial-gradient(closest-side,#FFE0C4,transparent_70%)]" />
              <div className="relative">
                <div className="text-[11px] font-mono tracking-widest text-[#E85A18]">0{i + 1}</div>
                <div
                  className="mt-3 text-[42px] lg:text-[48px] font-semibold text-[#0F1B2D] leading-none tracking-tight"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  <CountUp to={num} suffix={suffix} decimals={decimals} />
                </div>
                <div className="mt-3 text-[14px] font-medium text-[#0F1B2D]">{s.label}</div>
                <div className="mt-1 text-[12.5px] text-slate-500">{s.sub}</div>
              </div>
            </div>
          );})}
        </div>

        <div className="mt-16">
          <div className="text-[12.5px] uppercase tracking-[0.22em] text-slate-500 font-semibold text-center">
            Partners & Clinical Network
          </div>
          <div className="mt-6 flex flex-wrap justify-center items-center gap-3">
            {PARTNERS.map((p) => (
              <div
                key={p}
                className="rounded-full border border-orange-100 bg-white/70 backdrop-blur px-4 py-2 text-[13px] text-slate-700 hover:border-[#FF7A2E] hover:text-[#E85A18] transition-colors"
              >
                {p}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
